var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wb-entries"},_vm._l((_vm.state.tags),function(tag){return _c('a',{key:tag.Name,class:("wb-weight" + (tag.Weight)),attrs:{"href":tag.Url}},[_vm._v(" "+_vm._s(tag.Name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }